module.exports = __webpack_public_path__ + "img/award-10.18586f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards/award-10.jpg
// module id = 613
// module chunks = 1